import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// La URL se hornea en el bundle en tiempo de build, no se lee en runtime: un
// `serve -s build` sirviendo un build viejo puede estar pegandole a produccion
// aunque corra en localhost. De ahi el banner.
const PRODUCTION_API_HOSTS = ['filial-roja-api-94c18da96b56.herokuapp.com'];

export const isProductionApi = (url = API_BASE_URL) => {
    try {
        return PRODUCTION_API_HOSTS.includes(new URL(url).hostname);
    } catch {
        // Si no parsea, asumimos que no es produccion: preferimos un banner de
        // mas que uno de menos.
        return false;
    }
};

const api = axios.create({
    baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('isAuthenticated');
            window.location.reload();
        }
        return Promise.reject(error);
    }
);

export default api;